import React from "react";
import styles from "./404.module.scss";
import Button from "components/core/Button/Button";

type Props = {
  title?: string;
};

const Four04 = (props: Props) => {
  return (
    <div className={styles.Four04}>
      <div className="container">
        <div className={styles.Four04__layoutContainer}>
          <h2>Uh Oh!</h2>
          <p>
            {`We couldn't find the page you're looking for. Please
            visit another page or return home.`}
          </p>
          <Button className={styles.CTA} type="primary" href="/">
            Return Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Four04;
